import HmacSHA256 from 'crypto-js/hmac-sha256'
import enc from 'crypto-js/enc-base64'
import AES from 'crypto-js/aes'

export const encodeSHA256 = (data: any, token: string) => {
  const hash = HmacSHA256(JSON.stringify(data), token)
  const hashInBase64 = enc.stringify(hash)
  return hashInBase64
}

export const encryptAES = (message: any, token: string) => {
  return AES.encrypt(JSON.stringify(message), token).toString()
}
